module.exports = __webpack_public_path__ + "img/tree-06-d-trunk.ff74fa31.png";